// Подмешиваю к компонентам, к которым буду скролить при нажатии кнопки заказа при ошибках валидации
export const CLASS_FOR_SCROLL_TO_ERROR = 'scroll_to_error_class_name'

export const cargoTypeRequirements = {
  'small-van': 'van',
  van: 'lcv_m',
  gazelle: 'lcv_l',
}

export const cargoTypeRequirementsToUrl: Record<string, string> = {
  van: 'small-van',
  lcv_m: 'van',
  lcv_l: 'gazelle',
}

export const cargoTypeIntRequirements = {
  'small-van': 1,
  van: 2,
  gazelle: 3,
}

export const cargoTypeIntRequirementsToUrl = {
  '1': 'small-van',
  '2': 'van',
  '3': 'gazelle',
}
